import './HeroWidgetStyles.css';

import { cn } from '@/lib/utils';

export const HERO_WIDGET_DONE_CHECKBOX = cn(
  'pointer-events-none size-5 gap-0 p-0',
  '[&_input]:size-5 [&_input]:rounded-sm [&_input]:border-0',
  '[&_input]:bg-success-900 [&_input]:hover:bg-success-900',
  '[&_label]:hidden [&_span]:size-5 [&_span]:text-success-400'
);

export const HERO_WIDGET_PENDING_INDICATOR =
  'flex size-5 items-center justify-center rounded-sm bg-gray-dark-900 text-tertiary-500';

export const HERO_WIDGET_EXAMPLE_BADGE = cn(
  'cursor-pointer !outline-none',
  'px-2.5 py-1',
  'border border-brand-500/22 bg-brand-500/22 text-gray-dark-400 transition-colors hover:bg-brand-500/35 focus:bg-brand-500/35'
);

export const HERO_WIDGET_EXAMPLE_BADGE_SELECTED = cn(
  'cursor-pointer !outline-none',
  'px-2.5 py-1',
  'border border-brand-500/70 bg-brand-500/70 text-base-dark-white'
);

export const HERO_WIDGET_ICON_WRAPPER = cn(
  'flex items-center justify-center rounded-sm p-1 text-brand-400 size-8',
  'ScrapingHero_iconWrapper'
);

export const HERO_WIDGET_STEP_PANEL = 'flex flex-col p-5';

export const HERO_WIDGET_SUCCESS_BADGE = cn(
  'mt-3 w-full justify-start outline-none',
  'rounded-xl border border-success-500/20 bg-success-500/40',
  'px-2 py-2',
  '[&_*]:text-success-400 [&_*]:tracking-normal [&_*]:font-mono'
);
